import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "carousel-container position-relative" }
const _hoisted_2 = { class: "carousel__item_v3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "gradient-box" }, null, -1)
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide = _resolveComponent("slide")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_carousel, {
      "items-to-show": 1,
      autoplay: 0,
      wrapAround: true,
      transition: 750
    }, {
      addons: _withCtx(() => [
        _createVNode(_component_navigation),
        _createVNode(_component_pagination)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.image, (slide) => {
          return (_openBlock(), _createBlock(_component_slide, { key: slide }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("img", {
                  class: "carousel__item__image_v3",
                  src: _ctx.imageUrl(slide.path),
                  style: {"aspect-ratio":"1/1"}
                }, null, 8, _hoisted_4)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}